module.exports = __webpack_public_path__ + "static/media/1920-service-1-3-min.29ddba8d.jpg";